import * as React from "react";

import Box from "@mui/material/Box";

import { isEmpty } from "lodash";

import { CustomFilterOption } from "components/custom-filters-list/custom-filters-list.component";
import FilterChip from "components/custom-filters-list/filter-chip.component";
import Filter from "components/custom-filters-list/filter.component";

import FilterDropDownButton from "./filter-dropdown-button.component";

type Props = {
  option: CustomFilterOption;
  handleSetFilterData: (value: string, data: any) => void;
  isEdit: boolean;
  selectedFiltersMeta: any;
  metadata: any;
  handleClearMetadata: (value: string) => void;
  onStartEdit: (value: string) => void;
  onFinishEdit: (value: string) => void;
  isLocked?: boolean;
  isPinned?: boolean;
};

export default function FilterDropDown({
  option,
  handleSetFilterData,
  isEdit,
  selectedFiltersMeta,
  metadata,
  handleClearMetadata,
  onStartEdit,
  onFinishEdit,
  isLocked = false,
  isPinned = false
}: Props) {
  const [open, setOpen] = React.useState<null | Boolean>(false);
  const containerRef = React.useRef<any>();
  const { filterKey, label, editComponent, onDelete, renderViewMode } = option;

  const handleClick = () => {
    setOpen(!open);
    if (editComponent) {
      onStartEdit(filterKey);
    }
  };

  const handleDelete = () => {
    handleClearMetadata(filterKey);
    if (onDelete) {
      onDelete(filterKey);
    }
  };
  // A pinned filter has a value and no way to change it, so it never falls back to the
  // "nothing selected yet" button.
  const hasNoValue =
    isEmpty(selectedFiltersMeta) ||
    !selectedFiltersMeta.hasOwnProperty(filterKey) ||
    !selectedFiltersMeta[filterKey] ||
    (Array.isArray(selectedFiltersMeta[filterKey]) &&
      selectedFiltersMeta[filterKey].length === 0);

  if (!isPinned && (hasNoValue || isEdit)) {
    return (
      <Box sx={{ position: "relative" }}>
        <FilterDropDownButton
          label={label}
          handleClick={handleClick}
          open={open}
        />
        {isEdit && (
          <Box
            sx={{
              position: "absolute",
              top: "35px",
              zIndex: 1300,
              background: "white",
              borderRadius: "16px"
            }}
          >
            <Filter
              key={option.filterKey}
              option={option}
              metadata={selectedFiltersMeta[option.filterKey]}
              isEdit={isEdit}
              onStartEdit={onStartEdit}
              onFinishEdit={onFinishEdit}
              handleClearMetadata={handleClearMetadata}
              handleSetFilterData={handleSetFilterData}
            />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box ref={containerRef}>
      <FilterChip
        label={renderViewMode ? renderViewMode(filterKey, metadata) : label}
        onDelete={handleDelete}
        onClick={handleClick}
        isLocked={isLocked}
        isPinned={isPinned}
      />
    </Box>
  );
}
